import { node } from 'prop-types';
import { createContext, useContext, useMemo, useReducer } from 'react';

import contextActions from './mapContextActions.context';
import initialState from './MapContextInitState.context';

/**
 * @typedef MapContext
 * @property {Object} state
 * @property {Function} dispatch
 */

/**
 * @template T
 * @param {React.ReducerAction<React.Reducer<string, T>>} action
 */
const dispatchInit = (action: any) => action;

/**
 * @type {React.Context<MapContext>}
 */
const MapContext = createContext({ state: initialState, dispatch: dispatchInit });

const appReducer = (state: any, action: any) => {
	switch (action.type) {
		case contextActions.SET_CURRENT_NOTARIO:
			return {
				...state,
				currentNotario: action.data,
			};
		case contextActions.SET_ADMIN_USER_CONFIG:
			return {
				...state,
				adminUserConfig: action.data,
			};
		case contextActions.SET_MANAGE_ADMIN_TAB:
			return {
				...state,
				manageAdminTab: action.data,
			};
		case contextActions.SET_MARKERS:
			return {
				...state,
				markersCoords: action.data,
			};
		case contextActions.SET_NOTARIOS_DATA:
			return {
				...state,
				notariosData: action.data,
			};
		case contextActions.SET_USER_LOCATION:
			return {
				...state,
				userLocation: action.data,
			};
		case contextActions.SET_NOTARIOS_LOCATIONS:
			return {
				...state,
				notariosLocations: action.data,
			};
		default:
			return state;
	}
};

/**
 * @typedef {import('../interfaces/containers/container.interface').ContainerProps} ContainerProps
 */

/**
 * Componente que genera un Context Provider de la aplicación
 *
 * @component
 * @param {ContainerProps} props - Propiedades del componente
 * @returns {React.ReactElement} - Devuelve un componente
 */

const MapContextProvider = ({ children }: any) => {
	const [state, dispatch] = useReducer(appReducer, initialState);
	 
	const value = useMemo(() => ({ 
		state, 
		dispatch 
	}), [state]);
	return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};

const useMapContext = () => useContext(MapContext);

MapContextProvider.propTypes = {
	children: node.isRequired,
};

export { MapContextProvider, useMapContext };
